import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateLicenseOfferRequest, LicenseOffer, LicenseOfferResponse, UpdateLicenseOfferRequest } from '@models/csp';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LicenseOffersService {
  private readonly url = `${environment.bffUrl}/csp/license-offers`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<LicenseOffer[]> {
    return this.http.get<LicenseOfferResponse[]>(this.url);
  }

  add(request: CreateLicenseOfferRequest): Observable<LicenseOffer> {
    return this.http.post<LicenseOfferResponse>(this.url, request);
  }

  update(id: string, request: UpdateLicenseOfferRequest): Observable<LicenseOffer> {
    return this.http.put<LicenseOfferResponse>(`${this.url}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
